import {basePostRequest} from "../base/basePostRequest";
import {UserReport} from "./getUserReports";

const postUserReport = async (userReport: UserReport) =>
  basePostRequest<UserReport>("/user_report/", userReport);

export default postUserReport;
